"use strict";

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
var _classCallCheck = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var msRest = require("ms-rest-js");
var Mappers = require("../models/mappers");
var WebResource = msRest.WebResource;
/** Class representing a GlobalUsers. */
var GlobalUsers = /*#__PURE__*/function () {
  /**
   * Create a GlobalUsers.
   * @param {ManagedLabsClient} client Reference to the service client.
   */
  function GlobalUsers(client) {
    _classCallCheck(this, GlobalUsers);
    this.client = client;
  }
  /**
   * List all Environments for the user
   *
   * @param {string} userName The name of the user.
   *
   * @param {RequestOptionsBase} [options] Optional Parameters.
   *
   * @returns {Promise} A promise is returned
   *
   * @resolve {HttpOperationResponse} - The deserialized result object.
   *
   * @reject {Error|ServiceError} - The error object.
   */
  return _createClass(GlobalUsers, [{
    key: "listAllEnvironmentsWithHttpOperationResponse",
    value: function listAllEnvironmentsWithHttpOperationResponse(userName, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper, deserializationError;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              client = this.client; // Validate
              _context.prev = 1;
              if (!(userName === null || userName === undefined || typeof userName.valueOf() !== 'string')) {
                _context.next = 4;
                break;
              }
              throw new Error('userName cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context.next = 6;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 6:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context.next = 8;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 8:
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", Promise.reject(_context.t0));
            case 13:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'providers/Microsoft.LabServices/users/{userName}/listAllEnvironments';
              requestUrl = requestUrl.replace('{userName}', encodeURIComponent(userName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'POST';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              httpRequest.body = null;
              // Send Request
              _context.prev = 28;
              _context.next = 31;
              return client.pipeline(httpRequest);
            case 31:
              operationRes = _context.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context.next = 50;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context.prev = 40;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context.next = 49;
              break;
            case 45:
              _context.prev = 45;
              _context.t1 = _context["catch"](40);
              error.message = "Error \"".concat(_context.t1.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context.abrupt("return", Promise.reject(error));
            case 49:
              return _context.abrupt("return", Promise.reject(error));
            case 50:
              if (!(statusCode === 200)) {
                _context.next = 62;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context.prev = 52;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper = Mappers.ListAllEnvironmentsResponse;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context.next = 62;
              break;
            case 56:
              _context.prev = 56;
              _context.t2 = _context["catch"](52);
              deserializationError = new msRest.RestError("Error ".concat(_context.t2, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context.abrupt("return", Promise.reject(deserializationError));
            case 62:
              _context.next = 67;
              break;
            case 64:
              _context.prev = 64;
              _context.t3 = _context["catch"](28);
              return _context.abrupt("return", Promise.reject(_context.t3));
            case 67:
              return _context.abrupt("return", Promise.resolve(operationRes));
            case 68:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 10], [28, 64], [40, 45], [52, 56]]);
      }));
    }
    /**
     * Register a user to a managed lab
     *
     * @param {string} userName The name of the user.
     *
     * @param {RegisterPayload} registerPayload Represents payload for Register
     * action.
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "registerWithHttpOperationResponse",
    value: function registerWithHttpOperationResponse(userName, registerPayload, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, requestContent, requestModel, requestModelMapper, serializationError, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              client = this.client; // Validate
              _context2.prev = 1;
              if (!(userName === null || userName === undefined || typeof userName.valueOf() !== 'string')) {
                _context2.next = 4;
                break;
              }
              throw new Error('userName cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(registerPayload === null || registerPayload === undefined)) {
                _context2.next = 6;
                break;
              }
              throw new Error('registerPayload cannot be null or undefined.');
            case 6:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context2.next = 8;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context2.next = 10;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 10:
              _context2.next = 15;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](1);
              return _context2.abrupt("return", Promise.reject(_context2.t0));
            case 15:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'providers/Microsoft.LabServices/users/{userName}/register';
              requestUrl = requestUrl.replace('{userName}', encodeURIComponent(userName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'POST';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              // Serialize Request
              requestContent = null;
              requestModel = null;
              _context2.prev = 31;
              if (registerPayload !== null && registerPayload !== undefined) {
                requestModelMapper = Mappers.RegisterPayload;
                requestModel = client.serializer.serialize(requestModelMapper, registerPayload, 'registerPayload');
                requestContent = JSON.stringify(requestModel);
              }
              _context2.next = 39;
              break;
            case 35:
              _context2.prev = 35;
              _context2.t1 = _context2["catch"](31);
              serializationError = new Error("Error \"".concat(_context2.t1.message, "\" occurred in serializing the ") + "payload - ".concat(JSON.stringify(registerPayload, null, 2), "."));
              return _context2.abrupt("return", Promise.reject(serializationError));
            case 39:
              httpRequest.body = requestContent;
              // Send Request
              _context2.prev = 40;
              _context2.next = 43;
              return client.pipeline(httpRequest);
            case 43:
              operationRes = _context2.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context2.next = 62;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context2.prev = 52;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context2.next = 61;
              break;
            case 57:
              _context2.prev = 57;
              _context2.t2 = _context2["catch"](52);
              error.message = "Error \"".concat(_context2.t2.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context2.abrupt("return", Promise.reject(error));
            case 61:
              return _context2.abrupt("return", Promise.reject(error));
            case 62:
              _context2.next = 67;
              break;
            case 64:
              _context2.prev = 64;
              _context2.t3 = _context2["catch"](40);
              return _context2.abrupt("return", Promise.reject(_context2.t3));
            case 67:
              return _context2.abrupt("return", Promise.resolve(operationRes));
            case 68:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 12], [31, 35], [40, 64], [52, 57]]);
      }));
    }
    /**
     * Resets the user password on an environment This operation can take a while
     * to complete
     *
     * @param {string} userName The name of the user.
     *
     * @param {ResetPasswordPayload} resetPasswordPayload Represents the payload
     * for resetting passwords.
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "resetPasswordWithHttpOperationResponse",
    value: function resetPasswordWithHttpOperationResponse(userName, resetPasswordPayload, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var client, initialResult, operationRes;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              client = this.client; // Send request
              _context3.prev = 1;
              _context3.next = 4;
              return this.beginResetPasswordWithHttpOperationResponse(userName, resetPasswordPayload, options);
            case 4:
              initialResult = _context3.sent;
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", Promise.reject(_context3.t0));
            case 10:
              _context3.prev = 10;
              _context3.next = 13;
              return client.getLongRunningOperationResult(initialResult, options);
            case 13:
              operationRes = _context3.sent;
              _context3.next = 19;
              break;
            case 16:
              _context3.prev = 16;
              _context3.t1 = _context3["catch"](10);
              return _context3.abrupt("return", Promise.reject(_context3.t1));
            case 19:
              return _context3.abrupt("return", Promise.resolve(operationRes));
            case 20:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 7], [10, 16]]);
      }));
    }
    /**
     * Starts an environment by starting all resources inside the environment. This
     * operation can take a while to complete
     *
     * @param {string} userName The name of the user.
     *
     * @param {EnvironmentOperationsPayload} environmentOperationsPayload
     * Represents payload for any Environment operations like get, start, stop,
     * connect
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "startEnvironmentWithHttpOperationResponse",
    value: function startEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var client, initialResult, operationRes;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              client = this.client; // Send request
              _context4.prev = 1;
              _context4.next = 4;
              return this.beginStartEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options);
            case 4:
              initialResult = _context4.sent;
              _context4.next = 10;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](1);
              return _context4.abrupt("return", Promise.reject(_context4.t0));
            case 10:
              _context4.prev = 10;
              _context4.next = 13;
              return client.getLongRunningOperationResult(initialResult, options);
            case 13:
              operationRes = _context4.sent;
              _context4.next = 19;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t1 = _context4["catch"](10);
              return _context4.abrupt("return", Promise.reject(_context4.t1));
            case 19:
              return _context4.abrupt("return", Promise.resolve(operationRes));
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 7], [10, 16]]);
      }));
    }
    /**
     * Stops an environment by stopping all resources inside the environment This
     * operation can take a while to complete
     *
     * @param {string} userName The name of the user.
     *
     * @param {EnvironmentOperationsPayload} environmentOperationsPayload
     * Represents payload for any Environment operations like get, start, stop,
     * connect
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "stopEnvironmentWithHttpOperationResponse",
    value: function stopEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var client, initialResult, operationRes;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              client = this.client; // Send request
              _context5.prev = 1;
              _context5.next = 4;
              return this.beginStopEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options);
            case 4:
              initialResult = _context5.sent;
              _context5.next = 10;
              break;
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](1);
              return _context5.abrupt("return", Promise.reject(_context5.t0));
            case 10:
              _context5.prev = 10;
              _context5.next = 13;
              return client.getLongRunningOperationResult(initialResult, options);
            case 13:
              operationRes = _context5.sent;
              _context5.next = 19;
              break;
            case 16:
              _context5.prev = 16;
              _context5.t1 = _context5["catch"](10);
              return _context5.abrupt("return", Promise.reject(_context5.t1));
            case 19:
              return _context5.abrupt("return", Promise.resolve(operationRes));
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 7], [10, 16]]);
      }));
    }
    /**
     * Updates and returns personal user settings.
     *
     * @param {string} userName The name of the user.
     *
     * @param {UserSettingsPayload} userSettingsPayload Payload for the
     * userSettings operation.
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "userSettingsWithHttpOperationResponse",
    value: function userSettingsWithHttpOperationResponse(userName, userSettingsPayload, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, requestContent, requestModel, requestModelMapper, serializationError, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper, parsedResponse, _resultMapper2, deserializationError;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              client = this.client; // Validate
              _context6.prev = 1;
              if (!(userName === null || userName === undefined || typeof userName.valueOf() !== 'string')) {
                _context6.next = 4;
                break;
              }
              throw new Error('userName cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(userSettingsPayload === null || userSettingsPayload === undefined)) {
                _context6.next = 6;
                break;
              }
              throw new Error('userSettingsPayload cannot be null or undefined.');
            case 6:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context6.next = 8;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context6.next = 10;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 10:
              _context6.next = 15;
              break;
            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6["catch"](1);
              return _context6.abrupt("return", Promise.reject(_context6.t0));
            case 15:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'providers/Microsoft.LabServices/users/{userName}/userSettings';
              requestUrl = requestUrl.replace('{userName}', encodeURIComponent(userName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'POST';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              // Serialize Request
              requestContent = null;
              requestModel = null;
              _context6.prev = 31;
              if (userSettingsPayload !== null && userSettingsPayload !== undefined) {
                requestModelMapper = Mappers.UserSettingsPayload;
                requestModel = client.serializer.serialize(requestModelMapper, userSettingsPayload, 'userSettingsPayload');
                requestContent = JSON.stringify(requestModel);
              }
              _context6.next = 39;
              break;
            case 35:
              _context6.prev = 35;
              _context6.t1 = _context6["catch"](31);
              serializationError = new Error("Error \"".concat(_context6.t1.message, "\" occurred in serializing the ") + "payload - ".concat(JSON.stringify(userSettingsPayload, null, 2), "."));
              return _context6.abrupt("return", Promise.reject(serializationError));
            case 39:
              httpRequest.body = requestContent;
              // Send Request
              _context6.prev = 40;
              _context6.next = 43;
              return client.pipeline(httpRequest);
            case 43:
              operationRes = _context6.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200)) {
                _context6.next = 62;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context6.prev = 52;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context6.next = 61;
              break;
            case 57:
              _context6.prev = 57;
              _context6.t2 = _context6["catch"](52);
              error.message = "Error \"".concat(_context6.t2.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context6.abrupt("return", Promise.reject(error));
            case 61:
              return _context6.abrupt("return", Promise.reject(error));
            case 62:
              if (!(statusCode === 200)) {
                _context6.next = 74;
                break;
              }
              parsedResponse = operationRes.bodyAsJson;
              _context6.prev = 64;
              if (parsedResponse !== null && parsedResponse !== undefined) {
                _resultMapper2 = Mappers.UserSettingsResponse;
                operationRes.bodyAsJson = client.serializer.deserialize(_resultMapper2, parsedResponse, 'operationRes.bodyAsJson');
              }
              _context6.next = 74;
              break;
            case 68:
              _context6.prev = 68;
              _context6.t3 = _context6["catch"](64);
              deserializationError = new msRest.RestError("Error ".concat(_context6.t3, " occurred in deserializing the responseBody - ").concat(operationRes.bodyAsText));
              deserializationError.request = msRest.stripRequest(httpRequest);
              deserializationError.response = msRest.stripResponse(response);
              return _context6.abrupt("return", Promise.reject(deserializationError));
            case 74:
              _context6.next = 79;
              break;
            case 76:
              _context6.prev = 76;
              _context6.t4 = _context6["catch"](40);
              return _context6.abrupt("return", Promise.reject(_context6.t4));
            case 79:
              return _context6.abrupt("return", Promise.resolve(operationRes));
            case 80:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 12], [31, 35], [40, 76], [52, 57], [64, 68]]);
      }));
    }
    /**
     * Resets the user password on an environment This operation can take a while
     * to complete
     *
     * @param {string} userName The name of the user.
     *
     * @param {ResetPasswordPayload} resetPasswordPayload Represents the payload
     * for resetting passwords.
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "beginResetPasswordWithHttpOperationResponse",
    value: function beginResetPasswordWithHttpOperationResponse(userName, resetPasswordPayload, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, requestContent, requestModel, requestModelMapper, serializationError, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              client = this.client; // Validate
              _context7.prev = 1;
              if (!(userName === null || userName === undefined || typeof userName.valueOf() !== 'string')) {
                _context7.next = 4;
                break;
              }
              throw new Error('userName cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(resetPasswordPayload === null || resetPasswordPayload === undefined)) {
                _context7.next = 6;
                break;
              }
              throw new Error('resetPasswordPayload cannot be null or undefined.');
            case 6:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context7.next = 8;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context7.next = 10;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 10:
              _context7.next = 15;
              break;
            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7["catch"](1);
              return _context7.abrupt("return", Promise.reject(_context7.t0));
            case 15:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'providers/Microsoft.LabServices/users/{userName}/resetPassword';
              requestUrl = requestUrl.replace('{userName}', encodeURIComponent(userName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'POST';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              // Serialize Request
              requestContent = null;
              requestModel = null;
              _context7.prev = 31;
              if (resetPasswordPayload !== null && resetPasswordPayload !== undefined) {
                requestModelMapper = Mappers.ResetPasswordPayload;
                requestModel = client.serializer.serialize(requestModelMapper, resetPasswordPayload, 'resetPasswordPayload');
                requestContent = JSON.stringify(requestModel);
              }
              _context7.next = 39;
              break;
            case 35:
              _context7.prev = 35;
              _context7.t1 = _context7["catch"](31);
              serializationError = new Error("Error \"".concat(_context7.t1.message, "\" occurred in serializing the ") + "payload - ".concat(JSON.stringify(resetPasswordPayload, null, 2), "."));
              return _context7.abrupt("return", Promise.reject(serializationError));
            case 39:
              httpRequest.body = requestContent;
              // Send Request
              _context7.prev = 40;
              _context7.next = 43;
              return client.pipeline(httpRequest);
            case 43:
              operationRes = _context7.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200 && statusCode !== 202)) {
                _context7.next = 62;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context7.prev = 52;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context7.next = 61;
              break;
            case 57:
              _context7.prev = 57;
              _context7.t2 = _context7["catch"](52);
              error.message = "Error \"".concat(_context7.t2.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context7.abrupt("return", Promise.reject(error));
            case 61:
              return _context7.abrupt("return", Promise.reject(error));
            case 62:
              _context7.next = 67;
              break;
            case 64:
              _context7.prev = 64;
              _context7.t3 = _context7["catch"](40);
              return _context7.abrupt("return", Promise.reject(_context7.t3));
            case 67:
              return _context7.abrupt("return", Promise.resolve(operationRes));
            case 68:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 12], [31, 35], [40, 64], [52, 57]]);
      }));
    }
    /**
     * Starts an environment by starting all resources inside the environment. This
     * operation can take a while to complete
     *
     * @param {string} userName The name of the user.
     *
     * @param {EnvironmentOperationsPayload} environmentOperationsPayload
     * Represents payload for any Environment operations like get, start, stop,
     * connect
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "beginStartEnvironmentWithHttpOperationResponse",
    value: function beginStartEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, requestContent, requestModel, requestModelMapper, serializationError, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              client = this.client; // Validate
              _context8.prev = 1;
              if (!(userName === null || userName === undefined || typeof userName.valueOf() !== 'string')) {
                _context8.next = 4;
                break;
              }
              throw new Error('userName cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(environmentOperationsPayload === null || environmentOperationsPayload === undefined)) {
                _context8.next = 6;
                break;
              }
              throw new Error('environmentOperationsPayload cannot be null or undefined.');
            case 6:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context8.next = 8;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context8.next = 10;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 10:
              _context8.next = 15;
              break;
            case 12:
              _context8.prev = 12;
              _context8.t0 = _context8["catch"](1);
              return _context8.abrupt("return", Promise.reject(_context8.t0));
            case 15:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'providers/Microsoft.LabServices/users/{userName}/startEnvironment';
              requestUrl = requestUrl.replace('{userName}', encodeURIComponent(userName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'POST';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              // Serialize Request
              requestContent = null;
              requestModel = null;
              _context8.prev = 31;
              if (environmentOperationsPayload !== null && environmentOperationsPayload !== undefined) {
                requestModelMapper = Mappers.EnvironmentOperationsPayload;
                requestModel = client.serializer.serialize(requestModelMapper, environmentOperationsPayload, 'environmentOperationsPayload');
                requestContent = JSON.stringify(requestModel);
              }
              _context8.next = 39;
              break;
            case 35:
              _context8.prev = 35;
              _context8.t1 = _context8["catch"](31);
              serializationError = new Error("Error \"".concat(_context8.t1.message, "\" occurred in serializing the ") + "payload - ".concat(JSON.stringify(environmentOperationsPayload, null, 2), "."));
              return _context8.abrupt("return", Promise.reject(serializationError));
            case 39:
              httpRequest.body = requestContent;
              // Send Request
              _context8.prev = 40;
              _context8.next = 43;
              return client.pipeline(httpRequest);
            case 43:
              operationRes = _context8.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200 && statusCode !== 202)) {
                _context8.next = 62;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context8.prev = 52;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context8.next = 61;
              break;
            case 57:
              _context8.prev = 57;
              _context8.t2 = _context8["catch"](52);
              error.message = "Error \"".concat(_context8.t2.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context8.abrupt("return", Promise.reject(error));
            case 61:
              return _context8.abrupt("return", Promise.reject(error));
            case 62:
              _context8.next = 67;
              break;
            case 64:
              _context8.prev = 64;
              _context8.t3 = _context8["catch"](40);
              return _context8.abrupt("return", Promise.reject(_context8.t3));
            case 67:
              return _context8.abrupt("return", Promise.resolve(operationRes));
            case 68:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[1, 12], [31, 35], [40, 64], [52, 57]]);
      }));
    }
    /**
     * Stops an environment by stopping all resources inside the environment This
     * operation can take a while to complete
     *
     * @param {string} userName The name of the user.
     *
     * @param {EnvironmentOperationsPayload} environmentOperationsPayload
     * Represents payload for any Environment operations like get, start, stop,
     * connect
     *
     * @param {RequestOptionsBase} [options] Optional Parameters.
     *
     * @returns {Promise} A promise is returned
     *
     * @resolve {HttpOperationResponse} - The deserialized result object.
     *
     * @reject {Error|ServiceError} - The error object.
     */
  }, {
    key: "beginStopEnvironmentWithHttpOperationResponse",
    value: function beginStopEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var client, baseUrl, requestUrl, queryParamsArray, httpRequest, headerName, requestContent, requestModel, requestModelMapper, serializationError, operationRes, response, statusCode, error, parsedErrorResponse, resultMapper;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              client = this.client; // Validate
              _context9.prev = 1;
              if (!(userName === null || userName === undefined || typeof userName.valueOf() !== 'string')) {
                _context9.next = 4;
                break;
              }
              throw new Error('userName cannot be null or undefined and it must be of type string.');
            case 4:
              if (!(environmentOperationsPayload === null || environmentOperationsPayload === undefined)) {
                _context9.next = 6;
                break;
              }
              throw new Error('environmentOperationsPayload cannot be null or undefined.');
            case 6:
              if (!(this.client.apiVersion === null || this.client.apiVersion === undefined || typeof this.client.apiVersion.valueOf() !== 'string')) {
                _context9.next = 8;
                break;
              }
              throw new Error('this.client.apiVersion cannot be null or undefined and it must be of type string.');
            case 8:
              if (!(this.client.acceptLanguage !== null && this.client.acceptLanguage !== undefined && typeof this.client.acceptLanguage.valueOf() !== 'string')) {
                _context9.next = 10;
                break;
              }
              throw new Error('this.client.acceptLanguage must be of type string.');
            case 10:
              _context9.next = 15;
              break;
            case 12:
              _context9.prev = 12;
              _context9.t0 = _context9["catch"](1);
              return _context9.abrupt("return", Promise.reject(_context9.t0));
            case 15:
              // Construct URL
              baseUrl = this.client.baseUri;
              requestUrl = baseUrl + (baseUrl.endsWith('/') ? '' : '/') + 'providers/Microsoft.LabServices/users/{userName}/stopEnvironment';
              requestUrl = requestUrl.replace('{userName}', encodeURIComponent(userName));
              queryParamsArray = [];
              queryParamsArray.push('api-version=' + encodeURIComponent(this.client.apiVersion));
              if (queryParamsArray.length > 0) {
                requestUrl += '?' + queryParamsArray.join('&');
              }
              // Create HTTP transport objects
              httpRequest = new WebResource();
              httpRequest.method = 'POST';
              httpRequest.url = requestUrl;
              httpRequest.headers = {};
              // Set Headers
              httpRequest.headers['Content-Type'] = 'application/json; charset=utf-8';
              if (this.client.generateClientRequestId) {
                httpRequest.headers['x-ms-client-request-id'] = msRest.generateUuid();
              }
              if (this.client.acceptLanguage !== undefined && this.client.acceptLanguage !== null) {
                httpRequest.headers['accept-language'] = this.client.acceptLanguage;
              }
              if (options && options.customHeaders) {
                for (headerName in options.customHeaders) {
                  if (options.customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = options.customHeaders[headerName];
                  }
                }
              }
              // Serialize Request
              requestContent = null;
              requestModel = null;
              _context9.prev = 31;
              if (environmentOperationsPayload !== null && environmentOperationsPayload !== undefined) {
                requestModelMapper = Mappers.EnvironmentOperationsPayload;
                requestModel = client.serializer.serialize(requestModelMapper, environmentOperationsPayload, 'environmentOperationsPayload');
                requestContent = JSON.stringify(requestModel);
              }
              _context9.next = 39;
              break;
            case 35:
              _context9.prev = 35;
              _context9.t1 = _context9["catch"](31);
              serializationError = new Error("Error \"".concat(_context9.t1.message, "\" occurred in serializing the ") + "payload - ".concat(JSON.stringify(environmentOperationsPayload, null, 2), "."));
              return _context9.abrupt("return", Promise.reject(serializationError));
            case 39:
              httpRequest.body = requestContent;
              // Send Request
              _context9.prev = 40;
              _context9.next = 43;
              return client.pipeline(httpRequest);
            case 43:
              operationRes = _context9.sent;
              response = operationRes.response;
              statusCode = response.status;
              if (!(statusCode !== 200 && statusCode !== 202)) {
                _context9.next = 62;
                break;
              }
              error = new msRest.RestError(operationRes.bodyAsText);
              error.statusCode = response.status;
              error.request = msRest.stripRequest(httpRequest);
              error.response = msRest.stripResponse(response);
              parsedErrorResponse = operationRes.bodyAsJson;
              _context9.prev = 52;
              if (parsedErrorResponse) {
                if (parsedErrorResponse.error) parsedErrorResponse = parsedErrorResponse.error;
                if (parsedErrorResponse.code) error.code = parsedErrorResponse.code;
                if (parsedErrorResponse.message) error.message = parsedErrorResponse.message;
              }
              if (parsedErrorResponse !== null && parsedErrorResponse !== undefined) {
                resultMapper = Mappers.CloudError;
                error.body = client.serializer.deserialize(resultMapper, parsedErrorResponse, 'error.body');
              }
              _context9.next = 61;
              break;
            case 57:
              _context9.prev = 57;
              _context9.t2 = _context9["catch"](52);
              error.message = "Error \"".concat(_context9.t2.message, "\" occurred in deserializing the responseBody ") + "- \"".concat(operationRes.bodyAsText, "\" for the default response.");
              return _context9.abrupt("return", Promise.reject(error));
            case 61:
              return _context9.abrupt("return", Promise.reject(error));
            case 62:
              _context9.next = 67;
              break;
            case 64:
              _context9.prev = 64;
              _context9.t3 = _context9["catch"](40);
              return _context9.abrupt("return", Promise.reject(_context9.t3));
            case 67:
              return _context9.abrupt("return", Promise.resolve(operationRes));
            case 68:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 12], [31, 35], [40, 64], [52, 57]]);
      }));
    }
  }, {
    key: "listAllEnvironments",
    value: function listAllEnvironments(userName, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.listAllEnvironmentsWithHttpOperationResponse(userName, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.listAllEnvironmentsWithHttpOperationResponse(userName, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "register",
    value: function register(userName, registerPayload, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.registerWithHttpOperationResponse(userName, registerPayload, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.registerWithHttpOperationResponse(userName, registerPayload, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(userName, resetPasswordPayload, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.resetPasswordWithHttpOperationResponse(userName, resetPasswordPayload, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.resetPasswordWithHttpOperationResponse(userName, resetPasswordPayload, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "startEnvironment",
    value: function startEnvironment(userName, environmentOperationsPayload, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.startEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.startEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "stopEnvironment",
    value: function stopEnvironment(userName, environmentOperationsPayload, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.stopEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.stopEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "userSettings",
    value: function userSettings(userName, userSettingsPayload, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.userSettingsWithHttpOperationResponse(userName, userSettingsPayload, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.userSettingsWithHttpOperationResponse(userName, userSettingsPayload, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "beginResetPassword",
    value: function beginResetPassword(userName, resetPasswordPayload, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.beginResetPasswordWithHttpOperationResponse(userName, resetPasswordPayload, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.beginResetPasswordWithHttpOperationResponse(userName, resetPasswordPayload, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "beginStartEnvironment",
    value: function beginStartEnvironment(userName, environmentOperationsPayload, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.beginStartEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.beginStartEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }, {
    key: "beginStopEnvironment",
    value: function beginStopEnvironment(userName, environmentOperationsPayload, options, callback) {
      if (!callback && typeof options === 'function') {
        callback = options;
        options = undefined;
      }
      var cb = callback;
      if (!callback) {
        return this.beginStopEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options).then(function (operationRes) {
          return Promise.resolve(operationRes.bodyAsJson);
        }).catch(function (err) {
          return Promise.reject(err);
        });
      } else {
        msRest.promiseToCallback(this.beginStopEnvironmentWithHttpOperationResponse(userName, environmentOperationsPayload, options))(function (err, data) {
          if (err) {
            return cb(err);
          }
          var result = data.bodyAsJson;
          return cb(err, result, data.request, data.response);
        });
      }
    }
  }]);
}();
exports.GlobalUsers = GlobalUsers;